import styled, { css } from 'styled-components';
import { UpdateBanner } from '@yoweb/ui/components/UpdateBanner';
import { UPDATE_BANNER_ID } from '@poplar/constants/banners';
import { RepBanner, useRepBanner } from '@poplar/components/RepBanner';
import { th } from '@yoweb/ui/styles/utils/theme';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var DESKTOP_AVATAR_SIZE_KEY = 'display';
export var Banners = function Banners() {
  var _useRepBanner = useRepBanner(),
      subscriptionBanner = _useRepBanner.banner,
      subscription = _useRepBanner.subscription;

  return /*#__PURE__*/_jsxs(BannerContainer, {
    hasSpacing: true,
    children: [/*#__PURE__*/_jsx(UpdateBanner, {
      id: UPDATE_BANNER_ID
    }), /*#__PURE__*/_jsx(RepBanner, {
      banner: subscriptionBanner,
      subscription: subscription
    })]
  });
};
var BannerContainer = styled.div.withConfig({
  componentId: "sc-xah1va-0"
})(["", ""], function (_ref) {
  var hasSpacing = _ref.hasSpacing;
  return hasSpacing && css(["margin-bottom:", ";"], th.getSpace('normal1'));
});